import BaseFormModel from './models/baseFormModel';
import ApiController from '../api/apiController';
import AppAuthController from '../app/appAuthController';
import { formErrorMessages } from './constants/formErrorMessages';

const SELECTOR = '#reset-password-form';

const VALIDATION_SCHEME = {
    email: [
        {
            rule: 'required',
            errorMessage: formErrorMessages.required
        },
        {
            rule: 'email',
            errorMessage: formErrorMessages.email
        }
    ]
};

export default class ResetPasswordForm extends BaseFormModel {
    apiController;
    authController;

    constructor() {
        super();

        this.apiController = new ApiController();
        this.authController = new AppAuthController();

        this.init(SELECTOR, {
            validationScheme: VALIDATION_SCHEME,
            onSubmit: this.onSubmit
        });
    }

    async onSubmit() {
        const data = Object.fromEntries(new FormData(this.form));

        const result = await this.authController.resetPassword(data);

        if (!result.error) {
            this.showFormSuccess();
        }

        return result;
    }
}
